import styled, { css } from "styled-components";
import Spring from "../../components/Spring";

export const StyledSpring = styled(Spring)`
    margin-top: 50px;
    background-color: ${p => p.theme.c.snow};
`;

export const Description = styled.div`
    max-width: 560px;
    margin: auto;
    margin-bottom: 24px;
`;

export const Content = styled.div`
    margin: 16px 0;
    ul {
        margin: 2px 0;
    }
`;

export const Row = styled.span`
    display: block;
    > div {
        width: 50%;
        display: inline-block;
    }
`;

export const TaskWrap = styled.div`
    margin: 0;
`;

export const RhytLadderWrapper = styled.div`
    ${p =>
        p.theme.xs(css`
            width: 600px;
            margin-left: calc(-150px + (100vw - 320px) / 2.2);
            transform: scale(0.55);
        `)}

    > div > div {
        background-color: ${p => p.theme.c.snowOnActive};
        border-radius: 12px;
    }
`;

export const Container = styled.div`
    box-sizing: border-box;
    max-width: 680px;
    margin: auto;
    padding: 25px 25px 25px 26px;
    background-size: 100% auto;
    background-repeat: no-repeat;
    @media screen and (max-width: 696px) {
        padding: calc(100vw / 32);
    }
`;

export const Screen = styled.div`
    position: relative;
    overflow: hidden;
`;
